export const fontFamilies = [
  { label: 'Arial', value: 'Arial' },
  { label: 'Courier New', value: 'Courier New' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Times New Roman', value: 'Times New Roman' },
  { label: 'Trebuchet', value: 'Trebuchet' },
  { label: 'Verdana', value: 'Verdana' },
]

export const fontSizes = [
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' },
  { label: '13', value: '13' },
  { label: '14', value: '14' },
  { label: '16', value: '16' },
  { label: '18', value: '18' },
  { label: '20', value: '20' },
  { label: '22', value: '22' },
  { label: '24', value: '24' },
  { label: '26', value: '26' },
  { label: '28', value: '28' },
  { label: '30', value: '30' },
  { label: '32', value: '32' },
  { label: '36', value: '36' },
  { label: '40', value: '40' },
  { label: '48', value: '48' },
]

export const textStyleFields = [
  {
    key: 'header1',
    label: 'Título 1',
    defaultFont: 'Arial',
    defaultSize: 22,
    defaultBold: true,
    defaultItalic: false,
    defaultColor: '#000000',
  },
  {
    key: 'header2',
    label: 'Título 2',
    defaultFont: 'Arial',
    defaultSize: 18,
    defaultBold: true,
    defaultItalic: false,
    defaultColor: '#000000',
  },
  {
    key: 'header3',
    label: 'Título 3',
    defaultFont: 'Arial',
    defaultSize: 16,
    defaultBold: true,
    defaultItalic: false,
    defaultColor: '#000000',
  },
  {
    key: 'body',
    label: 'Cuerpo',
    defaultFont: 'Arial',
    defaultSize: 14,
    defaultBold: false,
    defaultItalic: false,
    defaultColor: '#000000',
  },
]

export const linkStyleDefaults = {
  defaultColor: '#1a73e8',
}
